"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
const rateReference_schema_1 = __importDefault(require("./schemas/rateReference.schema"));
class RateSheetValidator extends GenericValidator_1.default {
    _schema = joi_1.default.object({
        id: joi_1.default.string().allow('').required(),
        orgKey: joi_1.default.string().required(),
        name: joi_1.default.string()
            .max(200)
            .min(1)
            .trim()
            .pattern(/^[\w\d][\s\S]*/)
            .required(),
        description: joi_1.default.string().allow('').required(),
        rates: joi_1.default.array().items(rateReference_schema_1.default).unique().required(),
        assignedCustomers: joi_1.default.number().integer().min(0).optional(),
    });
    validate(input) {
        super.validate(input, 'IRateSheet', this._schema);
    }
}
exports.default = RateSheetValidator;
